var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07566 0.243468C6.40028 -0.0811558 6.9266 -0.0811558 7.25122 0.243468C7.57585 0.568091 7.57585 1.09441 7.25122 1.41903L2.83529 5.83496H12.4969C12.956 5.83496 13.3281 6.20712 13.3281 6.66621C13.3281 7.1253 12.956 7.49746 12.4969 7.49746H2.83855L7.25122 11.9101C7.57585 12.2348 7.57585 12.7611 7.25122 13.0857C6.9266 13.4103 6.40028 13.4103 6.07566 13.0857L0.273227 7.28327C0.115051 7.1404 0.0120718 6.93757 0.000124693 6.71062C-0.012434 6.48281 0.0682993 6.25083 0.242325 6.0768L6.07566 0.243468Z",
    fill: "#6E6E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.eb9087ef.svg";
export { ForwardRef as ReactComponent };